<template>
    <div class="home-bar-chart">
        <div class="header">
            <div class="title">
                開發量
                <word-tips-hover data="開發量 = 本月上架物件" width="180px"></word-tips-hover>
            </div>
            <div  v-if="isAllGroup" class="tips">
                <div>
                    <div class="dot district"></div>
                    <div>全部</div>
                </div>
            </div>
            <div  v-else class="tips">
                <div>
                    <div class="dot district"></div>
                    <div>{{userGroupName?userGroupName:'全部'}}</div>
                </div>
                <div>
                    <div class="dot avg"></div>
                    <div>平均</div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="chart">
                <div class="value">
                    <ul>
                        <li v-for="(item, index) in maxTotalSlice" :key="index">{{item}}</li>
                    </ul>
                </div>
                <div class="bar-chart-content">
                    <div v-if="isAllGroup" class="bar-chart-group">
                        <div class="single-bar" v-for="(item, index) in develop.monthlyDevelopmentAmount" :key="index">
                            <svg class="bar-chart" width="25" height="92" xmlns="http://www.w3.org/2000/svg" version="1.1">
                                <path class="bar"
                                    @mouseenter="showIncome(index, item.companyAverageDevelopmentAmount)"
                                    @mouseleave="hideIncome(index)"
                                    :stroke-dasharray="getBarChartPercent(item.companyAverageDevelopmentAmount)+',95'"
                                    stroke="#fcb773" stroke-width="6" stroke-linecap="round"
                                    d="M10 95 V15"
                                >
                                </path>
                                <!-- <path class="bar"
                                    @mouseenter="showExpense(index, item.expense)"
                                    @mouseleave="hideExpense(index)"
                                    :stroke-dasharray="getBarChartPercent(item.expense)+',95'"
                                    stroke="#3942b5" stroke-width="6" stroke-linecap="round"
                                    :d="'M17 95 V15'"
                                /> -->
                            </svg>
                            <div class="income-amount">{{toCurrency(item.companyAverageDevelopmentAmount)+'件'}}</div>
                            <!-- <div class="expense-amount">{{toCurrency(item.expense)+'件'}}</div> -->
                            <div class="date">
                                {{item.month}} <span>月</span> 
                            </div>
                        </div>
                    </div>
                    <div v-else class="bar-chart-group">
                        <div class="single-bar" v-for="(item, index) in develop.monthlyDevelopmentAmount" :key="index">
                            <svg class="bar-chart" width="25" height="92" xmlns="http://www.w3.org/2000/svg" version="1.1">
                                <path class="bar"
                                    @mouseenter="showIncome(index, item.groupDevelopmentAmount)"
                                    @mouseleave="hideIncome(index)"
                                    :stroke-dasharray="getBarChartPercent(item.groupDevelopmentAmount)+',95'"
                                    stroke="#fcb773" stroke-width="6" stroke-linecap="round"
                                    d="M5 95 V15"
                                >
                                </path>
                                <path class="bar"
                                    @mouseenter="showExpense(index, item.companyAverageDevelopmentAmount)"
                                    @mouseleave="hideExpense(index)"
                                    :stroke-dasharray="getBarChartPercent(item.companyAverageDevelopmentAmount)+',95'"
                                    stroke="#3942b5" stroke-width="6" stroke-linecap="round"
                                    :d="'M17 95 V15'"
                                />
                            </svg>
                            <div class="income-amount">{{toCurrency(item.groupDevelopmentAmount)+'件'}}</div>
                            <div class="expense-amount">{{toCurrency(item.companyAverageDevelopmentAmount)+'件'}}</div>
                            <div class="date">
                                {{item.month}} <span>月</span> 
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div v-if="isAllGroup" class="analysis">
                <div class="list">
                    <div v-if="develop.compareToLastMonthDevelopmentAmount" class="title">
                        您比上個月{{compareLastMonthIsPositive?'多':'少'}}開發的案件
                    </div>
                    <div v-else class="title">
                        上個月還沒有資料
                    </div>
                    <div class="up-low">
                        {{Object.keys(develop).length  !== 0  && develop.compareToLastMonthDevelopmentAmount !== null?toCurrency(Math.abs(develop.compareToLastMonthDevelopmentAmount)):'-'}} 件
                    </div>
                </div>
            </div>
            <div v-else class="analysis">
                <div class="list is-border">
                    <div class="title">
                        您比其他部門{{compareOtherGroupIsPositive?'多':'少'}}開發的案件
                    </div>
                    <div class="up-low">
                        {{Object.keys(develop).length  !== 0  && develop.compareToOtherGroupDevelopmentAmount !== null?toCurrency(Math.abs(develop.compareToOtherGroupDevelopmentAmount)):'-'}} 件
                    </div>
                </div>
                <div class="list">
                    <div v-if="develop.compareToLastMonthDevelopmentAmount" class="title">
                        您比上個月{{compareLastMonthIsPositive?'多':'少'}}開發的案件
                    </div>
                    <div v-else class="title">
                        上個月還沒有資料
                    </div>
                    <div class="up-low">
                        {{Object.keys(develop).length  !== 0  && develop.compareToLastMonthDevelopmentAmount !== null?toCurrency(Math.abs(develop.compareToLastMonthDevelopmentAmount)):'-'}} 件
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import { mapGetters } from 'vuex'
import { 
    apiBizGetDevelop
    } from "@/apis/api.js"; 

export default {
    data () {
        return{
            // inComeAndExpenseChart: {
            //     filter: 'WEEK',
            //     charPadding: 17,
            //     income:{
            //     },
            //     expense:{
            //     },
            //     dounutPercent: 0,
            //     chart:[
            //         {
            //             expense: 30,
            //             income: 50
            //         },
            //         {
            //             expense: 55,
            //             income: 60
            //         },
            //         {
            //             expense: 80,
            //             income: 48
            //         },
            //     ]
            // },
            develop: {}
        }
    },
    mounted () {
        this.getDevelop()
    },
    methods: {
        getDevelop: function () {
            apiBizGetDevelop()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.develop = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        isPositive: function (value) {
            if(value != undefined){
                // console.log(value)
                let result = Math.sign(value)
                if( result == 1 || result == 0){
                    return true
                }else{
                    return false
                }
            }
        },
        getBarChartPercent: function (value) {
            let maxTotal = this.carryNum?this.carryNum:100
            return (value/maxTotal)*80
        },
        showIncome: function(index, value) {
            // console.log(document.getElementsByClassName('income-amount'))
            let incomeItem = document.getElementsByClassName('income-amount')[index]
            let barHeight = this.getBarChartPercent(value)-13
            incomeItem.style.bottom = barHeight+'px'
            incomeItem.style.display = 'flex'
        },
        hideIncome: function(index, value) {
            let incomeItem = document.getElementsByClassName('income-amount')[index]
            incomeItem.style.display = 'none'
        },
        showExpense: function(index, value) {
            let expenseItem = document.getElementsByClassName('expense-amount')[index]
            let barHeight = this.getBarChartPercent(value)-13
            expenseItem.style.bottom = barHeight+'px'
            expenseItem.style.display = 'flex'
        },
        hideExpense: function(index, value) {
            let expenseItem = document.getElementsByClassName('expense-amount')[index]
            expenseItem.style.display = 'none'
        },
        toDoubleNum: function (value) {
            return (Array(2).join(0)+value).slice(-2)
        },
        getDecimal: function (value) {
            let numLength = value.toString().length
            let toDecimal = ''
            for (let i = 0; i < numLength; i++) {
                toDecimal += '0'
            }
            toDecimal = '0.'+toDecimal+'1'
            return parseFloat(toDecimal)
        },
        getInteger: function (value) {
            console.log(value)
            let numLength = value.toString().length
            let toInteger = ''
            for (let i = 0; i < numLength-1; i++) {
                toInteger += '0'
            }
            toInteger = '1'+toInteger
            return parseInt(toInteger)
        },
        getMax: function (value) {
            let max = 0
            for (let i = 0; i < value.length; i++) {
                const element = value[i];
                if (element.companyAverageDevelopmentAmount > max) {
                    max = element.companyAverageDevelopmentAmount;
                }
            }
            for (let i = 0; i < value.length; i++) {
                const element = value[i];
                if (element.groupDevelopmentAmount > max) {
                    max = element.groupDevelopmentAmount;
                }
            }
            // console.log('maxValue', max)
            return max
        },
    },
    computed: {
        compareOtherGroupIsPositive: function () {
            return this.isPositive(this.develop.compareToOtherGroupDevelopmentAmount)
        },
        compareLastMonthIsPositive: function () {
            return this.isPositive(this.develop.compareToLastMonthDevelopmentAmount)
        },
        maxTotalSlice: function () {
            let maxTotal  = this.carryNum?this.carryNum:1000
            
            let slice = []
            for (let i = 0; i <= 2; i++) {
                // console.log((maxTotal/4)*i)
                slice[i] = Math.round((maxTotal/2)*i)
            }
            return slice.reverse()
        },
        carryNum: function (value) {
            
            let maxValue  = parseInt(this.maxValue)
            let toMutiple = maxValue*1.1
            let toCeil = Math.ceil(toMutiple)
            let toMaxTotal = toCeil

            // console.log('最高金額:'+maxValue)
            // console.log('最高金額*1.1:'+toMutiple)
            // console.log('還原:'+toCeil)

            return toMaxTotal
        },
        maxValue: function (){
            let chart = this.develop.monthlyDevelopmentAmount
            return chart?this.getMax(chart): false
        },
        ...mapGetters({
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            userGroupName: 'GET_BIZ_GROUP_NAME',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'
        })
    },
    components: {
        wordTipsHover
    }
}
</script>
<style lang="scss" scoped>
    .home-bar-chart{
        width: 420px;
        height: 220px;
        padding: 20px 24px 30px;
        border-radius: 6px;
        backdrop-filter: blur(10px);
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        box-sizing: border-box;
        .header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 25px;
            .title{
                display: flex;
                font-size: 20px;
                font-weight: 500;
            }
            .tips{
                display: flex;
                align-items: center;
                >div{
                    display: flex;
                    align-items: center;
                    color: #676362;
                    font-size: 12px;
                    margin-left: 12px;
                    .dot{
                        position: relative;
                        background: #000;
                        width: 7px;
                        height: 7px;
                        border-radius: 4.5px;
                        margin-right: 4px;
                        &.district{
                            background:#fcb773;
                        }
                        &.avg{
                            background:#3942b5;
                        }
                    }
                }
            }
            // .tips{
            //     position: absolute;
            //     right: 24px;
            //     >div{
            //         margin-left: 20px;
            //     }
            //     .dot.empty{
            //         background: #3942b5;
            //     }
            //     .dot.rented{
            //         background: #fc7171;
            //     }
            // }
        }
        .content{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .chart {
                position: relative;
                display: flex;
                align-items: flex-end;
                .value{
                    margin-right: 12px;
                    position: relative;
                    bottom: 16px;
                    li{
                        text-align: center;
                        color: #a8a5a4;
                        line-height: 1.83;
                        font-size: 12px;
                        margin-top: 16px;
                    }
                }
                .bar-chart-content{
                    display: flex;
                    // background-image: url('../../../../../assets/img/component/financial_chart/chart_dash.png');
                    .bar-chart-group{
                        position: relative;
                        display: flex;
                        align-items: flex-end;
                        justify-content: space-around;
                        width: 180px;
                        bottom: 23px;
                        border-bottom: 1px solid #f3f3f3;
                        border-left: 1px solid #f3f3f3;
                        .single-bar{
                            position: relative;
                            margin-bottom: -2px;
                            .bar {
                                animation: bar-progress 1s ease-out forwards;
                            }
                            .date{
                                position: absolute;
                                color: #676362;
                                width: 50px;
                                margin-top: 7px;
                                font-size: 12px;
                            }
                            .income-amount,
                            .expense-amount{
                                position: absolute;
                                display: none;
                                align-items: center;
                                justify-content: center;
                                min-width: 50px;
                                left: 7px;
                                border-radius: 4px;
                                background-color: #676362;
                                color: #fff;
                                font-size: 12px;
                                padding: 8px 3px;
                                z-index: 20;
                            }
                            .expense-amount{
                                left: 21px;
                            }
                            .income-amount::before,
                            .expense-amount::before{
                                content: '';
                                position: absolute;
                                width: 0;
                                height: 0;
                                left: -4px;
                                border-style: solid;
                                border-width: 3px 4px 3px 0;
                                border-color: transparent #676362 transparent transparent;
                            }
                        }
                        
                    }
                }
             
            }
            .analysis{
                .list{
                    padding-top: 12px;
                    padding-bottom: 8px;
                    &.is-border{
                        border-bottom: 1px solid #f3f3f3;
                    }
                    .title{
                        font-size: 12px;
                        margin-bottom: 8px;
                    }
                    .up-low{
                        font-size: 16px;
                        color: #71aae5;
                        line-height: 1.5;
                    }
                }
            }
          
        }
        @keyframes progress {
            0% {
                stroke-dasharray: 0 100;
            }
        }
        @keyframes bar-progress {
            0% {
                stroke-dasharray: 0 200;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/chart/homeBarChart.vue